// extracted by mini-css-extract-plugin
export default {"darkGradient":"TcR1d","lightGradient":"p1Sl9","skeleton-progress":"OKuyy"};